import PropTypes from 'prop-types';
import { globalSettingsShape, layoutDataShape } from 'Helpers/props-shapes';

const configShape = {
  config: PropTypes.shape({
    newsletter: PropTypes.object,
    ...globalSettingsShape,
  }).isRequired,
};

export const homePropsShape = {
  ...layoutDataShape,
  ...configShape,
};
